<template>
    <div class="hcm-page">
      <div class="hcm-content">
      <router-view />
      </div>
      <AppTabbar />
    </div>
  

</template>
<script>

import AppTabbar from "@/components/mobile/AppTabbar";
export default {
    data () {
        return {
    
        };
    },
    components: {  AppTabbar },
    methods:{
    
    }
}
</script>
<style  lang="less">
@import "../assets/style/mcommon.less";

</style>


// WEBPACK FOOTER //
// src/layout/M.vue